import { Component, input, output } from '@angular/core';

export interface StatusChipItem {
  id: string;
  label: string;
  count: number;
  /** Cor suave (Linear-style): hex ou classe Tailwind bg/ring */
  color?: string;
}

@Component({
  selector: 'app-status-chips',
  standalone: true,
  template: `
    <div class="flex flex-wrap items-center gap-2 pl-1 sm:pl-2">
      <button
        type="button"
        (click)="statusSelect.emit(null)"
        class="h-8 px-3 rounded-full text-[12px] font-semibold tracking-wide transition-[background-color,color,box-shadow] duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus)] border border-transparent"
        [class.bg-[color-mix(in_srgb,var(--text)_8%,var(--hover))]]="selectedId() === null"
        [class.text-[var(--text)]]="selectedId() === null"
        [class.shadow-[0_0_0_1px_color-mix(in_srgb,var(--border)_55%,transparent)]]="selectedId() === null"
        [class.text-[var(--muted)]]="selectedId() !== null"
        [class.hover:bg-[color-mix(in_srgb,var(--hover)_65%,transparent)]]="selectedId() !== null"
      >
        Todos
      </button>
      @for (s of statuses(); track s.id) {
        <button
          type="button"
          (click)="statusSelect.emit(s.id)"
          class="h-8 min-h-8 pl-2.5 pr-3 rounded-full text-[12px] font-semibold tracking-[0.01em] transition-[background-color,color,box-shadow,border-color] duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus)] inline-flex items-center gap-2 border"
          [class.border-transparent]="selectedId() !== s.id"
          [class.border-[color-mix(in_srgb,var(--border)_45%,transparent)]]="selectedId() === s.id"
          [class.hover:bg-[color-mix(in_srgb,var(--hover)_45%,transparent)]]="selectedId() !== s.id"
          [style.background]="selectedId() === s.id && s.color ? 'color-mix(in srgb, ' + s.color + ' 14%, transparent)' : null"
          [class.bg-[var(--hover)]]="selectedId() === s.id && !s.color"
          [class.text-[var(--text)]]="selectedId() === s.id"
          [class.text-[var(--muted)]]="selectedId() !== s.id"
          [class.shadow-[0_1px_2px_rgb(15_23_42/0.04)]]="selectedId() === s.id"
        >
          @if (s.color) {
            <span
              class="w-2 h-2 rounded-full shrink-0 ring-1 ring-[color-mix(in_srgb,var(--border)_40%,transparent)]"
              [style.background-color]="s.color"
            ></span>
          }
          <span class="max-w-[14rem] sm:max-w-[18rem] truncate">{{ s.label }}</span>
          <span class="tabular-nums opacity-75 text-[11px] font-semibold">({{ s.count }})</span>
        </button>
      }
    </div>
  `,
})
export class StatusChipsComponent {
  statuses = input.required<StatusChipItem[]>();
  selectedId = input<string | null>(null);
  statusSelect = output<string | null>();
}
